<template>
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <div :class="['sidebar', sidebarCollapsed ? 'collapsed' : 'expanded']" id="sidebar">
      <button class="btn toggle-btn w-100" @click="toggleSidebar">
        <i :class="sidebarCollapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
      </button>

      <ul class="list-unstyled mt-3">
        <li v-for="(menu, index) in menus" :key="index" class="mb-2">
          <template v-if="menu.items.length === 0">
            <a class="menu-link d-flex align-items-center" :href="menu.link" :title="menu.title">
              <i :class="menu.icon" class="me-2 fs-5"></i>
              <span v-if="!sidebarCollapsed">{{ menu.title }}</span>
            </a>
          </template>
          <template v-else>
            <button class="menu-link d-flex align-items-center w-100" @click="toggleCollapse(index)">
              <i :class="menu.icon" class="me-2 fs-5"></i>
              <span v-if="!sidebarCollapsed">{{ menu.title }}</span>
              <i
                v-if="!sidebarCollapsed"
                class="ms-auto"
                :class="collapseStates[index] ? 'bi bi-caret-down-fill' : 'bi bi-caret-right-fill'"
              ></i>
            </button>
            <ul v-show="collapseStates[index] && !sidebarCollapsed" class="submenu list-unstyled ps-4">
              <li v-for="(item, i) in menu.items" :key="i">
                <a :href="item.link" class="submenu-link"><i class="bi bi-circle"></i> {{ item.nome }}</a>
              </li>
            </ul>
          </template>
        </li>
      </ul>
    </div>
    <!-- /Sidebar -->
  </div>
</template>

<script setup>
import { ref } from 'vue'

const sidebarCollapsed = ref(false)
const collapseStates = ref({})

const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value
}

const toggleCollapse = (index) => {
  collapseStates.value[index] = !collapseStates.value[index]
}

const menus = [
  { title: 'Home', icon: 'bi bi-house-door-fill', link: '/', items: [] },
  
  {
    title: 'Cadastros',
    icon: 'bi bi-journal-plus',
    items: [
      { nome: 'Colaboradores', link: '/colaboradores' },
      { nome: 'Grupos', link: '/grupos' },
      { nome: 'Subgrupos', link: '/subgrupos' },
      { nome: 'Jornadas', link: '/jornadas' },
      { nome: 'Função', link: '/funcoes' },
      { nome: 'Zonas', link: '/zonas' },
    ]
  },
  {
    title: 'Controle',
    icon: 'bi bi-filetype-xml',
    items: [
      { nome: 'Registros de ponto', link: '/registrosdeponto' },
      { nome: 'Espelho de ponto', link: '/relespelhoponto' },
      { nome: 'Justificativas', link: '/justificativas' },
      { nome: 'Exportar registros', link: '/exportar' },
    ]
  },
  {
    title: 'Configurações',
    icon: 'bi bi-gear-fill',
    items: [
      { nome: 'Usuários', link: '/usuarios' },
      { nome: 'Empresas', link: '/empresas' },
    ]
  }
]
</script>

<style scoped>
#wrapper {
 
  overflow: hidden;
}

#sidebar.sidebar {
  background-color: #13534a;
  color: #fff;
  transition: width 0.3s ease;
  min-height: 100vh;
  padding: 1rem 0.5rem;
  overflow-x: hidden;
}

.sidebar.expanded {
  width: 200px;
}

.sidebar.collapsed {
  width: 70px;
}

.toggle-btn {
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
}

.menu-link {
  color: white;
  background: transparent;
  border: none;
  text-align: left;
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  transition: background 0.2s ease;
}

.menu-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.submenu-link {
  display: block;
  color: white;
  padding: 0.4rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.9rem;
  text-decoration: none;
  transition: background 0.2s ease;
}

.submenu-link:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.submenu {
  margin-top: 0.25rem;
  background-color: #d5d5d512;
}
</style>
